<template>
  <div :class="['st-profile-menu', {'expand': expand }]" v-if="user">
    <img
      src="~images_base/st-avatar.svg"
      alt="ST profile"
      class="st-icon st-avatar"
      @click="expand=!expand">
    <div class="profile-menu" v-show="expand">
      <div class="triangle-pointer"></div>
      <div class="profile-menu-item st-aologinid" v-if="user.aologinid">
        Signed in as
        <span>{{user.aologinid}}</span>
      </div>
      <div class="profile-menu-item st-logout-btn">
        <a :href="this.$premium.getLogoutUrl()">Log out</a>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  computed: mapState(['user']),
  data () {
    return {
      expand: false
    }
  }
}
</script>

<style lang="scss">
.st-icon {
  width: 30px;
  height: 30px;
  transform: scale(0.9);
  transition: transform 0.3s;
  vertical-align: middle;
  display: inline-table;

  @media (min-width: $d_medium) {
    width: 38px;
    height: 38px;

    &:hover {
      transform: scale(1);
    }
  }
}

.st-profile-menu {
  position: relative;
  z-index: 1;
  display: inline-block;

  .st-icon {
    margin-left: 5px;
    cursor: pointer;

    // @media (min-width: $d_medium) {
    //   margin-left: 10px;
    // }
  }

  .profile-menu {
    background-color: #ffffff;
    color: $black;
    position: absolute;
    width: 180px;
    right: 0;
    padding: 0 15px;
    font-family: $font-CuratorRegular;
    font-size: 15px;
    line-height: 26px;
    margin-top: 3.5px;
    border-radius: 3px;
    box-shadow: 0 0 3px rgba($black, 0.4);

    .triangle-pointer {
      position: absolute;
      top: -4px;
      right: 12px;
      border-bottom: 4px solid #ffffff;
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;

      @media (min-width: $d_medium) {
        right: 16px;
      }
    }

    .profile-menu-item {
      white-space: normal;
      padding: 15px 0;
      line-height: 20px;
    }

    .st-aologinid {
      color: rgba($black, 0.8);

      span {
        display: block;
        font-family: $font-CuratorBold;
        color: $black;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .st-logout-btn {
      border-top: 1px solid rgba($black, 0.2);
      display: block;

      a {
        line-height: 11px;
        display: block;
        border-bottom: 0;
      }
    }
  }

  .st-content-shared-social & {
    position: static;

    .st-icon {
      opacity: 0.6;
    }

    &.expand {
      .st-icon {
        opacity: 1;
      }
    }

    .profile-menu {
      background-color: transparent;
      width: auto;
      bottom: 40px;
      left: 0;
      border-radius: 0;
      border-top: none;
      border-bottom: 1px solid #ffffff;
      margin-top: 0;
      margin-bottom: 3.5px;
      z-index: 1;
      max-width: 100%;

      .triangle-pointer {
        top: auto;
        bottom: -3px;
        border-bottom: none;
        border-top: 3px solid $stblue;
        border-left: 3px solid transparent;
        border-right: 3px solid transparent;
        right: 22px;

        &::before {
          content: '';
          border-bottom: none;
          border-top: 5px solid #ffffff;
          border-left: 5px solid transparent;
          border-right: 5px solid transparent;
          position: absolute;
          top: auto;
          bottom: -2px;
          left: -5px;
          z-index: -1;
        }
      }

      .st-aologinid,
      .st-aologinid span,
      .st-logout-btn a {
        color: rgba(#ffffff, 0.6);
      }

      .st-logout-btn {
        border-color: rgba(#b1b2b4, 0.2);
      }

      .st-aologinid span {
        display: inline;
        white-space: normal;
      }
    }
  }
}
</style>
